import * as Joi from 'joi'

export const resetPasswordSchema = Joi.object({
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      'string.email': 'Um email segue o formato: nome@domínio.com',
      'string.empty': 'O E-mail precisa ser preenchido',
    }),
})
